import Swal from 'sweetalert2';
import '../assets/Styles/alert.css';

async function alertSuccess(msg, timer = 0) {
  const SweetAlertOptions = {
    title: '¡Correcto!',
    html: `<span style="font-family:Roboto;">${msg}</span>`,
    icon: 'success',
    confirmButtonColor: 'var(--v-success-base)',
    confirmButtonText: 'OK',
  };

  if (timer > 0) {
    SweetAlertOptions.timer = timer;
    SweetAlertOptions.timerProgressBar = true;
  }

  return await Swal.fire(SweetAlertOptions);
}

async function alertError(msg) {
  const SweetAlertOptions = {
    title: '¡Error!',
    html: `<span style="font-family:Roboto;">${msg}</span>`,
    icon: 'error',
    confirmButtonColor: 'var(--v-error-base)',
    confirmButtonText: 'OK',
  };
  return await Swal.fire(SweetAlertOptions);
}

async function alertErrorImg() {
  return Swal.fire({
    icon: 'error',
    title: '¡Error!',
    text: 'Error al procesar su solicitud',
    confirmButtonColor: 'green',
  });
}

async function alertWarning(text) {
  const SweetAlertOptions = {
    title: '¡Advertencia!',
    html: `<span style="font-family:Roboto;">${text}</span>`,
    icon: 'warning',
    iconColor: '#f2bd06',
    showCancelButton: false,
    confirmButtonText: 'OK',
    confirmButtonColor: '#f2bd06',
    reverseButtons: false,
  };
  return await Swal.fire(SweetAlertOptions);
}

async function alertWarningHtml(textHtml) {
  const SweetAlertOptions = {
    title: '¡Precaución!',
    html: textHtml,
    icon: 'warning',
    iconColor: '#f2bd06',
    showCancelButton: true,
    confirmButtonText: 'CONFIRMAR',
    confirmButtonColor: '#f2bd06',
    cancelButtonText: 'CANCELAR',
    cancelButtonColor: '#cf3832',
    reverseButtons: true,
  };
  return await Swal.fire(SweetAlertOptions);
}

async function alertWarningConfirmar(text) {
  const SweetAlertOptions = {
    title: '¡Precaución!',
    text: text,
    icon: 'warning',
    iconColor: '#f2bd06',
    showCancelButton: true,
    confirmButtonText: 'CONFIRMAR',
    confirmButtonColor: '#f2bd06',
    cancelButtonText: 'CANCELAR',
    cancelButtonColor: '#cf3832',
    reverseButtons: true,
  };
  return await Swal.fire(SweetAlertOptions);
}

async function alertaNotificacion(options) {
  const { icon, title, text } = options;
  const notificacion = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: toast => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    },
  });
  return notificacion.fire({
    icon,
    title,
    text,
  });
}

export {
  alertSuccess,
  alertError,
  alertErrorImg,
  alertWarning,
  alertWarningHtml,
  alertWarningConfirmar,
  alertaNotificacion,
};
